import React from 'react';

import { scale430 } from '@xingternal/tokens';

import { RecruiterCard } from './recruiter-card';
import { Carousel } from './recruiter-cards-list.styles';
import type { CompanyRecruitersDataType } from './recruiters-cards-list-container';

type RecruiterCardsListProps = {
  recruiters: CompanyRecruitersDataType[];
};

export const RecruiterCardsList: React.FC<RecruiterCardsListProps> = ({
  recruiters,
}) => {
  return (
    <Carousel
      itemWidth="346px"
      itemMinWidth="346px"
      itemMaxWidth="346px"
      itemHeight={scale430}
      itemMinHeight={scale430}
      itemMaxHeight={scale430}
      itemSnapPosition="center">
      {recruiters.map((cardData, index) => (
        <RecruiterCard
          {...cardData}
          cardPosition={index + 1}
          key={cardData.id}
        />
      ))}
    </Carousel>
  );
};
